import {EventBody} from './event-body.model';

export class PageView extends EventBody {

}
